module.exports = __webpack_public_path__ + "img/paximum.45d12e28.png";